import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Box, ButtonBase, Typography } from "@mui/material";
import { ChevronRight } from "lucide-react";
import { APPROVAL_KINDS } from "./approvalKinds";

// "Scripts › Videos" — the plan's two approval stages, in order. Switches
// between the same plan's boards (or the two board lists when there's no plan).

const ApprovalStageSwitch = ({ kind, planId }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.25,
        p: 0.5,
        bgcolor: "#fff",
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
      }}
    >
      {APPROVAL_KINDS.map((k, i) => {
        const active = k === kind;
        const { Icon } = k;
        return (
          <Fragment key={k.noun}>
            {i > 0 && <ChevronRight size={14} color="#9CA3AF" />}
            <ButtonBase
              onClick={() => !active && navigate(planId ? `${k.route}/${planId}` : k.route)}
              aria-current={active ? "page" : undefined}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.5,
                py: 0.75,
                borderRadius: "9px",
                color: active ? "#fff" : "#374151",
                background: active ? "linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)" : "transparent",
                "&:hover": { bgcolor: active ? undefined : "#F9FAFB" },
              }}
            >
              <Icon size={15} />
              <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
                {i + 1}. {k.Noun}s
              </Typography>
            </ButtonBase>
          </Fragment>
        );
      })}
    </Box>
  );
};

export default ApprovalStageSwitch;
